/* One server-based clock for the edition, native request and contact backup. */
(() => {
  const START = 1793916000000, END = 1794175200000;
  let currentRoot, currentClock;
  window.CSNovemberClock = {
    get(root) {
      if (root === currentRoot) return currentClock;
      if (currentClock) currentClock.dispose();
      currentRoot = root;
      const lifecycle = new AbortController(), options = {signal:lifecycle.signal};
      const listeners = new Set();
      let seconds = Number(root.dataset.nsNow), tick = performance.now(), timer;
      const now = () => Number.isSafeInteger(seconds) && seconds > 0
        ? seconds * 1000 + Math.max(0, performance.now() - tick) : NaN;
      const open = () => {
        const time = now();
        return Number.isFinite(time) && time >= START && time < END;
      };
      const sync = () => {
        clearTimeout(timer);
        if (!root.isConnected) { currentClock?.dispose(); return; }
        const time = now();
        const valid = Number.isFinite(time);
        const ready = root.dataset.nsModeReady === 'true';
        const editorTest = root.dataset.nsEditorTest === 'true';
        const phase = ready && (editorTest || open()) ? 'open'
          : valid && time >= END ? 'closed' : 'preview';
        root.dataset.nsPhase = phase;
        root.querySelectorAll('[data-ns-when-open]').forEach(el => { el.hidden = phase !== 'open'; });
        root.querySelectorAll('[data-ns-when-preview]').forEach(el => { el.hidden = phase !== 'preview'; });
        root.querySelectorAll('[data-ns-when-closed]').forEach(el => { el.hidden = phase !== 'closed'; });
        listeners.forEach(fn => fn());
        if (valid && time < END) {
          const boundary = time < START ? START : END;
          timer = setTimeout(sync, Math.max(1, Math.min(boundary-time, 2147483647)));
        }
      };
      currentClock = {
        now, open,
        subscribe(fn) { listeners.add(fn); fn(); return () => listeners.delete(fn); },
        dispose() { clearTimeout(timer); lifecycle.abort(); listeners.clear(); }
      };
      root.addEventListener('cs-ns:availability-time', event => {
        if (!Number.isSafeInteger(event.detail?.now) || event.detail.now <= 0) return;
        seconds = event.detail.now; tick = performance.now(); sync();
      }, options);
      document.addEventListener('visibilitychange', sync, options);
      window.addEventListener('pageshow', sync, options);
      window.addEventListener('pagehide', () => clearTimeout(timer), options);
      sync();
      return currentClock;
    }
  };
})();
